// src/hooks/useProductData.js
import { useEffect, useState } from 'react';
import api from '../api';

const useProductData = (endPoint) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!endPoint) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/products/qr`, {
          params: { endPoint },
        });
        setData(response.data);
      } catch (err) {
        setError(err.message || 'Error fetching data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endPoint]);

  return { data, loading, error };
};

export default useProductData;
